import * as IF from "infrontjs";
import template from './template.html';

class RoutineSelectionEdit extends HTMLElement
{
    constructor()
    {
        super();
        this._isConnected = false;
    }

    connectedCallback()
    {
        if ( false === this._isConnected )
        {
            this.root = this;
            this.app = IF.App.get();
            this.isStatic = this.hasAttribute( 'routine-id' ) && true === this.app.routineManager.isRoutineStatic( this.getAttribute( 'routine-id' ) ) ? true : false;
            if ( true === this.hasAttribute( 'routine-id' ) && 0 === parseInt( this.getAttribute( 'routine-id' ) ) )
            {
                // Check special case in case of custom routines (ie. routines with routineIds eq.0)
                this.isStatic = 'daily' === this.getAttribute( 'goal' ) ? true : false;
            }

            this.options = this.app.routineManager.getRoutineOptionsByRoutineId( this.getAttribute( 'routine-id' ) );
            this.render();

            if ( true === this.isStatic )
            {
                this.root.querySelector( '[data-type="btnDelete"]' ).addEventListener( 'click', () =>
                {
                    this.app.gui.showGenericConfirmModal( 'Routine wirklich löschen?', () => {
                        this.setAttribute( 'to-delete', true );
                        const event = new Event( 'updateRoutinePlanRequest' );
                        this.root.dispatchEvent( event );
                    });
                });
            }
            // Special case, daily-goals with custom values
            else if ( 'daily-goal' === this.getAttribute( 'category-id' ) && -1 < [ "22", "23" ].indexOf( this.getAttribute( 'routine-id' ) ) )
            {
                this.root.querySelector( '[data-type="btnEdit"]' ).addEventListener( 'click', () =>
                {
                    let selectionHtml = '';
                    for ( let oi = 0; oi < this.options.length; oi++ )
                    {
                        selectionHtml += `<div class="row" style="margin-bottom: 6px"><div class="col-12">`;
                        selectionHtml += `<button type="button" data-type="dynamicValue" data-value="${this.options[ oi ]}" class="btn btn-block btn-m rounded-xs text-uppercase shadow-s bg-primary mb-2">${this.options[ oi ]}</button>`;
                        selectionHtml += `</div></div>`;
                    }

                    const drContainer = this.app.gui.getDynamicRoutineModalContainer();
                    drContainer.querySelector( '[data-type="modal-closer"]' ).addEventListener( 'click', () =>
                    {
                        drContainer.querySelectorAll( '[data-type="dynamicValue"]' ).forEach( btn => btn.removeEventListeners( 'click' ) );
                        drContainer.querySelector( '[data-type="modal-closer"]' ).removeEventListeners( 'click' );
                        this.app.gui.hideDynamicRoutineModalContainer();
                    });

                    this.app.gui.showDynamicRoutineModalContainer( selectionHtml );

                    drContainer.querySelectorAll( '[data-type="dynamicValue"]' ).forEach( btn =>
                    {
                        btn.addEventListener( 'click', () => {
                            this.root.setAttribute( 'value', btn.getAttribute( 'data-value' ) );
                            drContainer.querySelector( '[data-type="modal-closer"]' ).click();
                            if ( btn.getAttribute( 'data-value' ) !== this.getAttribute( 'name' ) )
                            {
                                this.setAttribute( 'name', btn.getAttribute( 'data-value' ) );
                                const event = new Event( 'updateRoutinePlanRequest' );
                                this.root.dispatchEvent( event );
                            }
                        });
                    });
                });
            }
            else if ( 'weekly' === this.getAttribute( 'goal' ) )
            {
                this.root.querySelector( '[data-type="btnEdit"]' ).addEventListener( 'click', () =>
                {
                    const oldWeeklyFrequence = +this.getAttribute( 'weekly-frequence' );
                    const wfContainer = this.app.gui.getWeeklyFrequenceModalContainer();
                    wfContainer.querySelectorAll( '[data-type="weeklyFrequenceButton"]' ).forEach( btn =>
                    {
                        btn.addEventListener( 'click', () =>
                        {
                            let triggerUpdate = false;
                            const newWeeklyFrequence = +btn.getAttribute( 'data-times' );
                            if ( 0 === newWeeklyFrequence )
                            {
                                this.root.setAttribute( 'to-delete', true );
                                triggerUpdate = true;
                            }
                            else if ( newWeeklyFrequence !== oldWeeklyFrequence )
                            {
                                this.setAttribute( 'name', newWeeklyFrequence + this.getAttribute( 'name' ).substring( 1 ) );
                                this.root.setAttribute( 'weekly-frequence', newWeeklyFrequence );
                                triggerUpdate = true;
                            }

                            wfContainer.querySelectorAll( '[data-type="weeklyFrequenceButton"]' ).forEach( btn => btn.removeEventListeners( 'click' ) );
                            wfContainer.querySelector( '[data-type="modal-closer"]' ).removeEventListeners( 'click' );
                            this.app.gui.hideFrequenceModal();

                            if ( true === triggerUpdate )
                            {
                                const event = new Event( 'updateRoutinePlanRequest' );
                                this.root.dispatchEvent( event );
                            }
                        } );
                    } );
                    wfContainer.querySelector( '[data-type="modal-closer"]' ).addEventListener( 'click', () =>
                    {
                        wfContainer.querySelectorAll( '[data-type="weeklyFrequenceButton"]' ).forEach( btn => btn.removeEventListeners( 'click' ) );
                        wfContainer.querySelector( '[data-type="modal-closer"]' ).removeEventListeners( 'click' );
                        this.app.gui.hideFrequenceModal();
                    } );

                    this.app.gui.showFrequenceModal();
                });
            }
            /*
            this.root.addEventListener( 'click', () =>
            {
                if ( null !== this.customWeeklyFrequencies )
                {
                    const wfContainer = this.app.gui.getWeeklyFrequenceModalContainer();
                    wfContainer.querySelectorAll( '[data-type="weeklyFrequenceButton"]' ).forEach( btn =>
                    {
                        btn.addEventListener( 'click', () => {
                            this._onFrequenceSelection( btn.getAttribute( 'data-times' ) );
                        });
                    });
                    wfContainer.querySelector( '[data-type="modal-closer"]' ).addEventListener( 'click', () =>
                    {
                        wfContainer.querySelector( '[data-type="modal-closer"]' ).removeEventListeners( 'click' );
                        this.app.gui.hideFrequenceModal();
                    });
                    this.app.gui.showFrequenceModal( this.customWeeklyFrequencies );
                }
                else
                {
                    if ( this.container.classList.contains( 'checked' ) )
                    {
                        this.container.classList.remove( 'checked' );
                        this.setAttribute( 'checked', false );
                    }
                    else
                    {
                        this.container.classList.add( 'checked' );
                        this.setAttribute( 'checked', true);
                    }
                }
            });
             */

            this._isConnected = true;
        }
    }

    getValues()
    {
        return {
            id : this.hasAttribute( 'routine-id' ) ? this.getAttribute( 'routine-id' ) : 0,
            goal : this.getAttribute( 'goal' ),
            categoryId : this.getAttribute( 'category-id' ),
            name : this.getAttribute( 'name' ),
            icon : this.hasAttribute( 'icon' ) ? this.getAttribute( 'icon' ) : null,
            weeklyFrequence : this.hasAttribute( 'weekly-frequence' ) ? +this.getAttribute( 'weekly-frequence' ) : 7
         };
    }

    disconnectedCallback()
    {}

    render()
    {
        this.root.innerHTML = this.app.view.getHtml(
            template,
            {
                name : this.getAttribute( 'name' ),
                isStatic : this.isStatic,
                icon : this.getAttribute( 'icon' )
            }
        );
    }

}

customElements.define('routine-selection-edit', RoutineSelectionEdit );
